import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        searchResultsFeature: {
          module: () => import('./search-results.module').then((m) => m.SearchResultsModule),
        },
      }
    }),
  ]
})
export class SearchResultsFeatureModule {}
